import { AxiosResponse } from 'axios';

import { getRecordingSeasonEpisodesUrl } from 'config/api.ts';

import { ResponseError } from 'store/railsBuilder/reducer.types.ts';
import { RecordingResponse } from 'store/recordings/reducer.types.ts';

import NagraInstance from 'utils/axios/nagra/DefaultInstance.ts';

function requestRecordingEpisodesBySeason(
    seasonId: string,
    queryParams?: {
        page?: number;
        limit?: number;
    },
): Promise<AxiosResponse<RecordingResponse | ResponseError>> {
    return NagraInstance.get<RecordingResponse>(
        getRecordingSeasonEpisodesUrl(seasonId, queryParams),
    );
}

export default requestRecordingEpisodesBySeason;
